import { StateSchema } from 'app/config/storeConfig/types';
import { InvoiceItem } from 'entities/Invoice';

export const getInvoiceItems = (state: StateSchema): InvoiceItem[] => state.issueInvoiceModal.invoiceItems;
